import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "dayjs";
import classnames from "classnames";

const MIN_YEAR = 2019;

const CustomInputDatePicker = ({ value, label,extraProps, onChange = () => { }, className, inputClassName, ...props }) => {
  const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
  };

  // Typing a year char by char yields dates like 0202/1920; ignore anything out of range
  const isInRange = (d) => d.getFullYear() >= MIN_YEAR;

  const handleDateChange = (date) => {
    if (isValidDate(date) && isInRange(date)) {
      onChange(moment(date).format("YYYY-MM-DD"));
    }
  };

  return (
    <>
      <div className={classnames("inputDatePicker", className)}>
        {label && <div className="inputDatePicker__label" style={{ color: '#757575' }}>{label}</div>}
        <ReactDatePicker
          disabledKeyboardNavigation
          minDate={new Date(MIN_YEAR, 0, 1)}
          {...props}
          selected={(() => {
            if (value instanceof Date && isValidDate(value)) return value;
            const parsed = moment(value, "YYYY-MM-DD");
            return parsed.isValid() ? parsed.toDate() : null;
          })()}
          onChange={handleDateChange}
          className={inputClassName ?? "mb-3"}
          dateFormat={"MM-dd-yyyy"}
          portalId="datepicker-portal"
          showMonthDropdown
          showYearDropdown
          placeholderText={label ? label : "MM-DD-YYYY"}
        />
      </div>
    </>
  );
};

export default CustomInputDatePicker;
